<template>

  <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12 md12 >
          <v-card>
             <v-list two-line subheader>
             <!-- <v-progress-linear :indeterminate="true" v-if="setLoading == true"></v-progress-linear>
             <center v-if="groups.length == 0 && setLoading == false" style="padding-top: 2%;">

                    <v-icon :size="40">local_play</v-icon>
                    <h2> No Groups Available </h2>
             <v-btn color="primary" @click="getTags">Retry</v-btn>
            </center> -->

            <div v-if="groups.length > 0">

            <v-list-item
              v-for="item in groups"
              :key="item.id"
              avatar
            >
              <v-list-item-avatar>
                <v-icon class="grey lighten-1 white--text">group_work</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>

                <v-btn icon ripple>
                   <v-icon
                    small
                    color="blue"
                    @click="editGroup(item)"
                  >
                    edit
                  </v-icon>
                </v-btn>

              <v-btn icon ripple>
                   <v-icon
                   color="red"
                    small
                    @click="deleteGroup(item)"
                  >
                    delete
                  </v-icon>
                </v-btn>

            </v-list-item>

            </div>

            <div align="center" v-else>

               <v-nodata :loading="loading.groupOption" title="" :networkError="networkError.groupOption" msgDetails="You haven't added any groups yet" icon="group_work" contentBg="lighten-4"  @retryMethod="getGroups">
               </v-nodata>

            </div>

          </v-list>


          </v-card>

          <v-dialog v-model="groupDialog" max-width="500" persistent>
           <template v-slot:activator="{ on }">
           <v-btn
               slot="activator"
                color="primary"
                dark
                fixed
                bottom
                right
                fab
              >
                <v-icon>add</v-icon>

              </v-btn>
             </template>

                <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitleGroup }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                        <v-text-field v-model="editedItem.name" label="Group Name" ref="groupNameRules" required :rules="groupNameRules"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click.native="closeGroup">Cancel</v-btn>
                  <v-btn v-if="formTitleGroup == 'New Group'" color="blue darken-1" x-large  dark @click.native="addGroup">Add Group</v-btn>
                  <v-btn v-if="formTitleGroup == 'Edit Group'" color="blue darken-1" x-large  dark @click.native="addGroup">Update Group</v-btn>
                </v-card-actions>
              </v-card>

            </v-dialog>

        </v-flex>


      </v-layout>


  </v-container>

</template>

<script>

import { mapState } from 'vuex'
import VNodata from '@/components/Unavailable/nodata.vue'

export default {
  components: { VNodata },
  data() {
    return {
      groupNameRules: [
        v => !!v || 'Enter a GroupName',
        v => /^[A-Za-z0-9\-][a-zA-Z0-9 ]+[a-zA-Z0-9]*$/.test(v) || 'Please enter a valid GroupName',
      ],
      loading: {
        groupOption: true,

      },
      networkError: {
        groupOption: false,

      },
      groupDialog: false,
      groups: [],
      editedIndexGroup: -1,
      setLoading: true,
      editedItem: {
        name: '',
      },
      defaultItem: {
        name: '',
      },
      updateTagId: '',
    };
  },
  computed: {
    formTitleGroup() {
      return this.editedIndexGroup === -1 ? 'New Group' : 'Edit Group';
    },
  },
  watch: {
    groupDialog(val) {
      val || this.closeGroup();
    },
  },
  created() {
    this.getGroups();
  },
  methods: {
    // canSee(what,role,options){
    //   return canSee(this,what,role,options)
    // },

    getGroups() {
      const self = this;

      this.loading.groupOption = true;

      // this.setLoading = true
      this.$http.get(`${this.$store.state.endpoint}groups/get`).then((response) => {
        this.loading.groupOption = false;

        self.$store.dispatch('getGroups');

     
        this.groups = [];
        this.groups = response.body;

        //  this.setLoading = false
      }, (error) => {
        console.log(error);
        this.loading.groupOption = false;
        this.networkError.groupOption = true;
      });
    },
    closeGroup() {
      
      this.$refs.groupNameRules.resetValidation()
      this.groupDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndexGroup = -1;
      }, 300);
    },

    editGroup(item) {
      this.editedIndexGroup = this.groups.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.updateTagId = item.id;
      this.groupDialog = true;
    },
    deleteGroup(item) {
      const self = this;
      const itemObj = item.id;
      // write item delete code
      this.$http.delete(`${this.$store.state.endpoint}groups/${itemObj}`).then((response) => {
        self.getGroups();
      }, (error) => {
        self.$swal({ type: 'error', text: error.body.error.message });
      });
    },

    addGroup() {
      if (this.$refs.groupNameRules.validate() == false) {
      
        this.$swal({
          type: 'warning',
          text: 'Please Enter GroupName',
        });
      } else {
       
        const self = this;
        if (this.editedIndexGroup > -1) {
          const updateObj = {
            name: this.editedItem.name,
          };

          this.$http.patch(`${this.$store.state.endpoint}groups/${this.updateTagId}`, updateObj).then((response) => {
            self.getGroups();
            self.$refs.groupNameRules.resetValidation()
          }, (error) => {
            console.log(error);
          });
          this.$swal({
            type: 'success',
            text: 'Successfully updated',
          });
          this.closeGroup();
        } else if (this.$refs.groupNameRules.validate() == false) {
          
        } else {
        
          const postObj = {
            name: this.editedItem.name,
            companyId: this.$store.state.userDetails.companyId,
          };
            // validation for group Name
          for (const x in self.groups) {
            if ((postObj.name).toLowerCase() == (self.groups[x].name).toLowerCase()) {
              self.$swal({ type: 'warning', text: 'Enter a different group name' });
              return;
            }
          }
          this.$http.post(`${this.$store.state.endpoint}groups`, postObj)
            .then((response) => {
              self.getGroups();
              self.$refs.groupNameRules.resetValidation()
            }, (error) => {
              console.log(error);
            });
          this.closeGroup();
        }
      }


      // this.closeGroup()
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

/* .v-list__tile__title, .v-list__tile__sub-title {
    white-space: inherit!important;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
}

*/

.v-list__tile__title, .v-list__tile__sub-title {

  word-wrap: break-word!important;
  white-space: normal!important;
  overflow: initial!important;

}
</style>
